export const PROFILE_TYPE = {
	SPECIALTY: 2,
	TRADE: 3,
	DISCIPLINES: 4,
} as const;

export type ProfileTypeId =
	(typeof PROFILE_TYPE)[keyof typeof PROFILE_TYPE];

export const TAB_ROUTES = {
	OFFICE_LOCATIONS: "company-locations",
	SECTORS_SPECIALTY: "sectors-speciality",
	PROJECTS: "projects",
	KEY_PERSONNEL: "resources",
	CORPORATE_DOCUMENTS: "corporate-documents",
} as const;

export type TabRouteId = (typeof TAB_ROUTES)[keyof typeof TAB_ROUTES];

export interface TabConfig {
	id: TabRouteId;
	name: string;
	testId: string;
}

export const getTabLabel = (profileTypeId: number): string => {
	switch (profileTypeId) {
		case PROFILE_TYPE.SPECIALTY:
			return "Specialty";
		case PROFILE_TYPE.TRADE:
			return "Trade";
		case PROFILE_TYPE.DISCIPLINES:
			return "Disciplines";
		default:
			return "Disciplines";
	}
};
